import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makesMutations, makesQueries } from 'data/graphql'
import { dataFetched } from 'data/graphql/reducer'
import { createErrorToasterMessage } from 'data/ui/actions'
import {
  channelAttrsFragment,
  channelMembershipsFragment,
} from 'remote/channels'

const channelWithMembershipsQuery = gql`
  query ChannelWithAdminChannelMembers($channelId: ID!) {
    showChannel(channelId: $channelId) {
      ...channelAttrs
      ...channelMembershipsAttrs
    }
  }
  ${channelAttrsFragment}
  ${channelMembershipsFragment}
`

export const providesChannelMemberships = compose(
  connect(
    null,
    { dataFetched }
  ),
  makesQueries({
    query: channelWithMembershipsQuery,
    mapPropsToVariables: ({ channelId }) => ({ channelId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.showChannel, meta)
    },
  })
)

export const providesChannelRolesMutations = compose(
  connect(
    null,
    {
      dataFetched,
      createErrorToasterMessage,
    }
  ),
  makesMutations({
    query: gql`
      mutation updateUserRoleInChannel(
        $channelId: ID!
        $userId: ID!
        $role: ChannelMemberRole!
      ) {
        updateUserRoleInChannel(
          channelId: $channelId
          userId: $userId
          role: $role
        ) {
          ... on ChannelRoleChangeInterface {
            previousRole
            nextRole
            subject {
              ... on User {
                __typename
                id
              }
            }
          }
          ... on ChannelRoleSwitch {
            channel {
              __typename
              id
              ...channelMembershipsAttrs
            }
          }
        }
      }
      ${channelMembershipsFragment}
    `,
    mutationPropName: 'updateUserRoleInChannel',
    getOnResultFromProps: ({ dataFetched, forceQuery }) => ({
      result,
      meta,
    }) => {
      if (meta.variables.role === 'none') {
        forceQuery && forceQuery()
      } else {
        dataFetched(result.data.updateUserRoleInChannel.channel)
      }
    },

    getOnErrorFromProps: ({ createErrorToasterMessage }) => ({ error }) => {
      createErrorToasterMessage({
        title: error.message,
      })
    },
  }),
  makesMutations({
    query: gql`
      mutation updateUserGroupRoleInChannel(
        $channelId: ID!
        $userGroupId: ID!
        $role: ChannelMemberRole!
      ) {
        updateUserGroupRoleInChannel(
          channelId: $channelId
          userGroupId: $userGroupId
          role: $role
        ) {
          ... on ChannelRoleChangeInterface {
            previousRole
            nextRole
            subject {
              ... on UserGroup {
                __typename
                id
              }
            }
          }
          ... on ChannelRoleSwitch {
            channel {
              __typename
              id
              ...channelMembershipsAttrs
            }
          }
        }
      }
      ${channelMembershipsFragment}
    `,
    mutationPropName: 'updateUserGroupRoleInChannel',
    getOnResultFromProps: ({ dataFetched, forceQuery }) => ({
      result,
      meta,
    }) => {
      if (meta.variables.role === 'none') {
        forceQuery && forceQuery()
      } else {
        dataFetched(result.data.updateUserGroupRoleInChannel.channel)
      }
    },
    getOnErrorFromProps: ({ createErrorToasterMessage }) => ({ error }) => {
      createErrorToasterMessage({
        title: error.message,
      })
    },
  })
)
